import { render, staticRenderFns } from "./VideoModule.vue?vue&type=template&id=02ed8e3b&scoped=true"
import script from "./VideoModule.vue?vue&type=script&lang=js"
export * from "./VideoModule.vue?vue&type=script&lang=js"
import style0 from "./VideoModule.vue?vue&type=style&index=0&id=02ed8e3b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ed8e3b",
  null
  
)

export default component.exports